import React from 'react'
import '../styles/global.css'
import Footer from './Footer'
import NavBar from './NavBar'
import { cn } from '../utils'

// “browser globals” like window or document that aren’t available in Node.js.

interface LayoutProps {
  children: React.ReactNode
  background?: 'light' | 'dark'
}

export const Layout = ({ children, background = 'dark' }: LayoutProps) => {
  return (
    <div className={cn(background)}>
      <div className={cn('bg-default-1000')}>
        <NavBar />
        {children}
        <Footer />
      </div>
    </div>
  )
}
